var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#EBEEF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_56366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1445 8.66421H10.3445C9.22443 8.66421 8.66437 8.66421 8.23655 8.8822C7.86023 9.07395 7.55426 9.37991 7.36252 9.75623C7.14453 10.1841 7.14453 10.7441 7.14453 11.8642V17.4642C7.14453 18.5843 7.14453 19.1444 7.36252 19.5722C7.55426 19.9485 7.86023 20.2545 8.23655 20.4462C8.66437 20.6642 9.22443 20.6642 10.3445 20.6642H15.9445C17.0646 20.6642 17.6247 20.6642 18.0525 20.4462C18.4288 20.2545 18.7348 19.9485 18.9265 19.5722C19.1445 19.1444 19.1445 18.5843 19.1445 17.4642V14.6642M11.1445 16.6642H12.2609C12.587 16.6642 12.7501 16.6642 12.9035 16.6274C13.0396 16.5947 13.1696 16.5408 13.2889 16.4677C13.4235 16.3853 13.5388 16.27 13.7694 16.0394L20.1445 9.66421C20.6968 9.11193 20.6968 8.2165 20.1445 7.66421C19.5922 7.11193 18.6968 7.11193 18.1445 7.66421L11.7694 14.0394C11.5388 14.27 11.4234 14.3853 11.341 14.5198C11.2679 14.6391 11.214 14.7692 11.1814 14.9052C11.1445 15.0587 11.1445 15.2217 11.1445 15.5479V16.6642Z",
    stroke: "#1B2444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoinjoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_56366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.5133baaed0b6bb8d0a892cca78794359.svg";
export { ForwardRef as ReactComponent };